import { render, staticRenderFns } from "./MyJobOpenings.vue?vue&type=template&id=28b80dda&scoped=true&"
import script from "./MyJobOpenings.vue?vue&type=script&lang=js&"
export * from "./MyJobOpenings.vue?vue&type=script&lang=js&"
import style0 from "./MyJobOpenings.vue?vue&type=style&index=0&id=28b80dda&lang=scss&scoped=true&"
import style1 from "./MyJobOpenings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b80dda",
  null
  
)

export default component.exports